@if (isLoggedIn() && !isTokenExpired()) {
  <div class="main-layout">
    <app-sidebar />
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  </div>
} @else {
  <router-outlet></router-outlet>
}
